import React from 'react';
import TokenedView from '../../components/tokened-view';

export const withToken = WrappedComponent => () => (
  <TokenedView>
    <WrappedComponent />
  </TokenedView>
);
